import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import { getitemList } from "@/api/gmtool/packageCode";
import { serchSelect, tabulation, customPaging } from "@/mixins/index";
export default {
  name: "ItemListN",
  mixins: [serchSelect, tabulation, customPaging],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      PrimitiveData: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      // this.paramsData.page = e
      this.reqLoading = true;
      getitemList(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this2.currentPage = 1;
          _this2.PrimitiveData = res.data;
          _this2.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
          _this2.tableData = _this2.currentChangePage(_this2.pageSize, _this2.currentPage);
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    Refresh: function Refresh() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.list = [];

                _this3.getList(1);

                _context2.next = 4;
                return _this3.$store.commit('gmTool/init/set_isreqItemList', false);

              case 4:
                _this3.$store.dispatch('gmTool/init/getItemList');

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: 'id'
      }, {
        label: this.$t('nameLabel'),
        prop: 'kind'
      }, {
        label: this.$t('type'),
        prop: 'type'
      }];
      var data = [{
        id: 'item_id',
        kind: 'item_name',
        type: 'item_type'
      }].concat(_toConsumableArray(this.PrimitiveData));
      this.$export.csv({
        columns: columns,
        data: data,
        noHeader: true,
        title: this.$route.meta.title
      });
    }
  }
};